// export class SearchCompany {
//   public companyName: string = '';
//   public registerType: string = '';
// }

export class SearchCompany implements ISearchCompany {
  public companyType: string = null;
  public name: string = null;

  constructor(options?: ISearchCompany) {
    this.companyType = options && options.companyType;
    this.name = options && options.name;
  }
}

export interface ISearchCompany {
  companyType?: string;
  name?: string;
}
